/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class WxQrCodeManageServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 消息通知微信
     * @return OK
     */
    bundlingMp(): Promise<ROfWxAccountFans> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/manage/wxQrCode/bundlingMp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBundlingMp(_response);
        });
    }

    protected processBundlingMp(response: AxiosResponse): Promise<ROfWxAccountFans> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWxAccountFans.fromJS(resultData200) : new ROfWxAccountFans();
            return result200;
        }
        return Promise.resolve<ROfWxAccountFans>(<any>null);
    }

    /**
     * 创建带参二维码ticket
     * @param form form
     * @return OK
     */
    createTicket(form: WxQrCodeForm): Promise<ROfWxMpQrCodeTicket> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/manage/wxQrCode/createTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateTicket(_response);
        });
    }

    protected processCreateTicket(response: AxiosResponse): Promise<ROfWxMpQrCodeTicket> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWxMpQrCodeTicket.fromJS(resultData200) : new ROfWxMpQrCodeTicket();
            return result200;
        }
        return Promise.resolve<ROfWxMpQrCodeTicket>(<any>null);
    }

    /**
     * 解绑消息通知微信
     * @return OK
     */
    unbundlingMp(): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/manage/wxQrCode/unbundlingMp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnbundlingMp(_response);
        });
    }

    protected processUnbundlingMp(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class WxKitServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getSignature
     * @param appId appId
     * @param url url
     * @return OK
     */
    getSignature(appId: string, url: string): Promise<WxJsapiSignature> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/mpkit/signature?";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined and cannot be null.");
        else
            url_ += "appId=" + encodeURIComponent("" + appId) + "&"; 
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSignature(_response);
        });
    }

    protected processGetSignature(response: AxiosResponse): Promise<WxJsapiSignature> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WxJsapiSignature.fromJS(resultData200) : new WxJsapiSignature();
            return result200;
        }
        return Promise.resolve<WxJsapiSignature>(<any>null);
    }
}

export class WxPortalServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * authGet
     * @param appId appId
     * @param echostr (optional) echostr
     * @param nonce (optional) nonce
     * @param signature (optional) signature
     * @param timestamp (optional) timestamp
     * @return OK
     */
    authGet(appId: string, echostr: string | null | undefined, nonce: string | null | undefined, signature: string | null | undefined, timestamp: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/portal/{appId}?";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        if (echostr !== undefined)
            url_ += "echostr=" + encodeURIComponent("" + echostr) + "&"; 
        if (nonce !== undefined)
            url_ += "nonce=" + encodeURIComponent("" + nonce) + "&"; 
        if (signature !== undefined)
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain;charset=utf-8"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthGet(_response);
        });
    }

    protected processAuthGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * post
     * @param appId appId
     * @param encrypt_type (optional) encrypt_type
     * @param msg_signature (optional) msg_signature
     * @param nonce nonce
     * @param openid openid
     * @param requestBody requestBody
     * @param signature signature
     * @param timestamp timestamp
     * @return OK
     */
    post(appId: string, encrypt_type: string | null | undefined, msg_signature: string | null | undefined, nonce: string, openid: string, requestBody: string, signature: string, timestamp: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/portal/{appId}?";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId)); 
        if (encrypt_type !== undefined)
            url_ += "encrypt_type=" + encodeURIComponent("" + encrypt_type) + "&"; 
        if (msg_signature !== undefined)
            url_ += "msg_signature=" + encodeURIComponent("" + msg_signature) + "&"; 
        if (nonce === undefined || nonce === null)
            throw new Error("The parameter 'nonce' must be defined and cannot be null.");
        else
            url_ += "nonce=" + encodeURIComponent("" + nonce) + "&"; 
        if (openid === undefined || openid === null)
            throw new Error("The parameter 'openid' must be defined and cannot be null.");
        else
            url_ += "openid=" + encodeURIComponent("" + openid) + "&"; 
        if (signature === undefined || signature === null)
            throw new Error("The parameter 'signature' must be defined and cannot be null.");
        else
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/xml;charset=UTF-8"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class WxMaMediaServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getMedia
     * @param appid appid
     * @param mediaId mediaId
     * @return OK
     */
    getMedia(appid: string, mediaId: string): Promise<File> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/media/{appid}/download/{mediaId}";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (mediaId === undefined || mediaId === null)
            throw new Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMedia(_response);
        });
    }

    protected processGetMedia(response: AxiosResponse): Promise<File> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? File.fromJS(resultData200) : new File();
            return result200;
        }
        return Promise.resolve<File>(<any>null);
    }

    /**
     * uploadMedia
     * @param appid appid
     * @return OK
     */
    uploadMedia(appid: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/media/{appid}/upload";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadMedia(_response);
        });
    }

    protected processUploadMedia(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class WxMaPortalServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * authGet
     * @param appid appid
     * @param echostr (optional) echostr
     * @param nonce (optional) nonce
     * @param signature (optional) signature
     * @param timestamp (optional) timestamp
     * @return OK
     */
    authGet(appid: string, echostr: string | null | undefined, nonce: string | null | undefined, signature: string | null | undefined, timestamp: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/portal/{appid}?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (echostr !== undefined)
            url_ += "echostr=" + encodeURIComponent("" + echostr) + "&"; 
        if (nonce !== undefined)
            url_ += "nonce=" + encodeURIComponent("" + nonce) + "&"; 
        if (signature !== undefined)
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain;charset=utf-8"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAuthGet(_response);
        });
    }

    protected processAuthGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * post
     * @param appid appid
     * @param encrypt_type (optional) encrypt_type
     * @param msg_signature (optional) msg_signature
     * @param nonce nonce
     * @param requestBody requestBody
     * @param signature (optional) signature
     * @param timestamp timestamp
     * @return OK
     */
    post(appid: string, encrypt_type: string | null | undefined, msg_signature: string | null | undefined, nonce: string, requestBody: string, signature: string | null | undefined, timestamp: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/portal/{appid}?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (encrypt_type !== undefined)
            url_ += "encrypt_type=" + encodeURIComponent("" + encrypt_type) + "&"; 
        if (msg_signature !== undefined)
            url_ += "msg_signature=" + encodeURIComponent("" + msg_signature) + "&"; 
        if (nonce === undefined || nonce === null)
            throw new Error("The parameter 'nonce' must be defined and cannot be null.");
        else
            url_ += "nonce=" + encodeURIComponent("" + nonce) + "&"; 
        if (signature !== undefined)
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/xml;charset=UTF-8"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class WxMaUserServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * info
     * @param appid appid
     * @param encryptedData (optional) encryptedData
     * @param iv (optional) iv
     * @param rawData (optional) rawData
     * @param sessionKey (optional) sessionKey
     * @param signature (optional) signature
     * @return OK
     */
    info(appid: string, encryptedData: string | null | undefined, iv: string | null | undefined, rawData: string | null | undefined, sessionKey: string | null | undefined, signature: string | null | undefined): Promise<ROfWxMaUserInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/user/{appid}/info?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (encryptedData !== undefined)
            url_ += "encryptedData=" + encodeURIComponent("" + encryptedData) + "&"; 
        if (iv !== undefined)
            url_ += "iv=" + encodeURIComponent("" + iv) + "&"; 
        if (rawData !== undefined)
            url_ += "rawData=" + encodeURIComponent("" + rawData) + "&"; 
        if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&"; 
        if (signature !== undefined)
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInfo(_response);
        });
    }

    protected processInfo(response: AxiosResponse): Promise<ROfWxMaUserInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWxMaUserInfo.fromJS(resultData200) : new ROfWxMaUserInfo();
            return result200;
        }
        return Promise.resolve<ROfWxMaUserInfo>(<any>null);
    }

    /**
     * login
     * @param appid appid
     * @param code (optional) code
     * @return OK
     */
    login(appid: string, code: string | null | undefined): Promise<ROfWxMaJscode2SessionResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/user/{appid}/login?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<ROfWxMaJscode2SessionResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWxMaJscode2SessionResult.fromJS(resultData200) : new ROfWxMaJscode2SessionResult();
            return result200;
        }
        return Promise.resolve<ROfWxMaJscode2SessionResult>(<any>null);
    }

    /**
     * phone
     * @param appid appid
     * @param encryptedData (optional) encryptedData
     * @param iv (optional) iv
     * @param rawData (optional) rawData
     * @param sessionKey (optional) sessionKey
     * @param signature (optional) signature
     * @return OK
     */
    phone(appid: string, encryptedData: string | null | undefined, iv: string | null | undefined, rawData: string | null | undefined, sessionKey: string | null | undefined, signature: string | null | undefined): Promise<ROfWxMaPhoneNumberInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-wechat')+ "/wx/ma/user/{appid}/phone?";
        if (appid === undefined || appid === null)
            throw new Error("The parameter 'appid' must be defined.");
        url_ = url_.replace("{appid}", encodeURIComponent("" + appid)); 
        if (encryptedData !== undefined)
            url_ += "encryptedData=" + encodeURIComponent("" + encryptedData) + "&"; 
        if (iv !== undefined)
            url_ += "iv=" + encodeURIComponent("" + iv) + "&"; 
        if (rawData !== undefined)
            url_ += "rawData=" + encodeURIComponent("" + rawData) + "&"; 
        if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&"; 
        if (signature !== undefined)
            url_ += "signature=" + encodeURIComponent("" + signature) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPhone(_response);
        });
    }

    protected processPhone(response: AxiosResponse): Promise<ROfWxMaPhoneNumberInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfWxMaPhoneNumberInfo.fromJS(resultData200) : new ROfWxMaPhoneNumberInfo();
            return result200;
        }
        return Promise.resolve<ROfWxMaPhoneNumberInfo>(<any>null);
    }
}

export class File implements IFile {
    absolute!: boolean | undefined;
    absoluteFile!: File | undefined;
    absolutePath!: string | undefined;
    canonicalFile!: File | undefined;
    canonicalPath!: string | undefined;
    directory!: boolean | undefined;
    file!: boolean | undefined;
    freeSpace!: string | undefined;
    hidden!: boolean | undefined;
    name!: string | undefined;
    parent!: string | undefined;
    parentFile!: File | undefined;
    path!: string | undefined;
    totalSpace!: string | undefined;
    usableSpace!: string | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.absolute = data["absolute"];
            this.absoluteFile = data["absoluteFile"] ? File.fromJS(data["absoluteFile"]) : <any>undefined;
            this.absolutePath = data["absolutePath"];
            this.canonicalFile = data["canonicalFile"] ? File.fromJS(data["canonicalFile"]) : <any>undefined;
            this.canonicalPath = data["canonicalPath"];
            this.directory = data["directory"];
            this.file = data["file"];
            this.freeSpace = data["freeSpace"];
            this.hidden = data["hidden"];
            this.name = data["name"];
            this.parent = data["parent"];
            this.parentFile = data["parentFile"] ? File.fromJS(data["parentFile"]) : <any>undefined;
            this.path = data["path"];
            this.totalSpace = data["totalSpace"];
            this.usableSpace = data["usableSpace"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["absolute"] = this.absolute;
        data["absoluteFile"] = this.absoluteFile ? this.absoluteFile.toJSON() : <any>undefined;
        data["absolutePath"] = this.absolutePath;
        data["canonicalFile"] = this.canonicalFile ? this.canonicalFile.toJSON() : <any>undefined;
        data["canonicalPath"] = this.canonicalPath;
        data["directory"] = this.directory;
        data["file"] = this.file;
        data["freeSpace"] = this.freeSpace;
        data["hidden"] = this.hidden;
        data["name"] = this.name;
        data["parent"] = this.parent;
        data["parentFile"] = this.parentFile ? this.parentFile.toJSON() : <any>undefined;
        data["path"] = this.path;
        data["totalSpace"] = this.totalSpace;
        data["usableSpace"] = this.usableSpace;
        return data; 
    }
}

export interface IFile {
    absolute: boolean | undefined;
    absoluteFile: File | undefined;
    absolutePath: string | undefined;
    canonicalFile: File | undefined;
    canonicalPath: string | undefined;
    directory: boolean | undefined;
    file: boolean | undefined;
    freeSpace: string | undefined;
    hidden: boolean | undefined;
    name: string | undefined;
    parent: string | undefined;
    parentFile: File | undefined;
    path: string | undefined;
    totalSpace: string | undefined;
    usableSpace: string | undefined;
}

/** 返回信息 */
export class ROfWxAccountFans implements IROfWxAccountFans {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WxAccountFans | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWxAccountFans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WxAccountFans.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWxAccountFans {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWxAccountFans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWxAccountFans {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WxAccountFans | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWxMaJscode2SessionResult implements IROfWxMaJscode2SessionResult {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WxMaJscode2SessionResult | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWxMaJscode2SessionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WxMaJscode2SessionResult.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWxMaJscode2SessionResult {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWxMaJscode2SessionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWxMaJscode2SessionResult {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WxMaJscode2SessionResult | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWxMaPhoneNumberInfo implements IROfWxMaPhoneNumberInfo {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WxMaPhoneNumberInfo | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWxMaPhoneNumberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WxMaPhoneNumberInfo.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWxMaPhoneNumberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWxMaPhoneNumberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWxMaPhoneNumberInfo {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WxMaPhoneNumberInfo | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWxMaUserInfo implements IROfWxMaUserInfo {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WxMaUserInfo | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWxMaUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WxMaUserInfo.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWxMaUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWxMaUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWxMaUserInfo {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WxMaUserInfo | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfWxMpQrCodeTicket implements IROfWxMpQrCodeTicket {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: WxMpQrCodeTicket | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfWxMpQrCodeTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? WxMpQrCodeTicket.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfWxMpQrCodeTicket {
        data = typeof data === 'object' ? data : {};
        let result = new ROfWxMpQrCodeTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfWxMpQrCodeTicket {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: WxMpQrCodeTicket | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class Watermark implements IWatermark {
    appid!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: IWatermark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appid = data["appid"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): Watermark {
        data = typeof data === 'object' ? data : {};
        let result = new Watermark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appid"] = this.appid;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IWatermark {
    appid: string | undefined;
    timestamp: string | undefined;
}

export class WxAccountFans implements IWxAccountFans {
    city!: string | undefined;
    country!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    gender!: string | undefined;
    headimgUrl!: string | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    language!: string | undefined;
    nickname!: string | undefined;
    openid!: string | undefined;
    province!: string | undefined;
    remark!: string | undefined;
    subscribeStatus!: string | undefined;
    subscribeTime!: Date | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    wxAccountAppid!: string | undefined;
    wxAccountId!: string | undefined;
    wxAccountName!: string | undefined;

    constructor(data?: IWxAccountFans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.city = data["city"];
            this.country = data["country"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.gender = data["gender"];
            this.headimgUrl = data["headimgUrl"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.language = data["language"];
            this.nickname = data["nickname"];
            this.openid = data["openid"];
            this.province = data["province"];
            this.remark = data["remark"];
            this.subscribeStatus = data["subscribeStatus"];
            this.subscribeTime = data["subscribeTime"] ? new Date(data["subscribeTime"].toString()) : <any>undefined;
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.wxAccountAppid = data["wxAccountAppid"];
            this.wxAccountId = data["wxAccountId"];
            this.wxAccountName = data["wxAccountName"];
        }
    }

    static fromJS(data: any): WxAccountFans {
        data = typeof data === 'object' ? data : {};
        let result = new WxAccountFans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["headimgUrl"] = this.headimgUrl;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["language"] = this.language;
        data["nickname"] = this.nickname;
        data["openid"] = this.openid;
        data["province"] = this.province;
        data["remark"] = this.remark;
        data["subscribeStatus"] = this.subscribeStatus;
        data["subscribeTime"] = this.subscribeTime ? this.subscribeTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["wxAccountAppid"] = this.wxAccountAppid;
        data["wxAccountId"] = this.wxAccountId;
        data["wxAccountName"] = this.wxAccountName;
        return data; 
    }
}

export interface IWxAccountFans {
    city: string | undefined;
    country: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    gender: string | undefined;
    headimgUrl: string | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    language: string | undefined;
    nickname: string | undefined;
    openid: string | undefined;
    province: string | undefined;
    remark: string | undefined;
    subscribeStatus: string | undefined;
    subscribeTime: Date | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    wxAccountAppid: string | undefined;
    wxAccountId: string | undefined;
    wxAccountName: string | undefined;
}

export class WxJsapiSignature implements IWxJsapiSignature {
    appId!: string | undefined;
    nonceStr!: string | undefined;
    signature!: string | undefined;
    timestamp!: string | undefined;
    url!: string | undefined;

    constructor(data?: IWxJsapiSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            this.nonceStr = data["nonceStr"];
            this.signature = data["signature"];
            this.timestamp = data["timestamp"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): WxJsapiSignature {
        data = typeof data === 'object' ? data : {};
        let result = new WxJsapiSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["nonceStr"] = this.nonceStr;
        data["signature"] = this.signature;
        data["timestamp"] = this.timestamp;
        data["url"] = this.url;
        return data; 
    }
}

export interface IWxJsapiSignature {
    appId: string | undefined;
    nonceStr: string | undefined;
    signature: string | undefined;
    timestamp: string | undefined;
    url: string | undefined;
}

export class WxMaJscode2SessionResult implements IWxMaJscode2SessionResult {
    openid!: string | undefined;
    sessionKey!: string | undefined;
    unionid!: string | undefined;

    constructor(data?: IWxMaJscode2SessionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.openid = data["openid"];
            this.sessionKey = data["sessionKey"];
            this.unionid = data["unionid"];
        }
    }

    static fromJS(data: any): WxMaJscode2SessionResult {
        data = typeof data === 'object' ? data : {};
        let result = new WxMaJscode2SessionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openid"] = this.openid;
        data["sessionKey"] = this.sessionKey;
        data["unionid"] = this.unionid;
        return data; 
    }
}

export interface IWxMaJscode2SessionResult {
    openid: string | undefined;
    sessionKey: string | undefined;
    unionid: string | undefined;
}

export class WxMaPhoneNumberInfo implements IWxMaPhoneNumberInfo {
    countryCode!: string | undefined;
    phoneNumber!: string | undefined;
    purePhoneNumber!: string | undefined;
    watermark!: Watermark | undefined;

    constructor(data?: IWxMaPhoneNumberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
            this.phoneNumber = data["phoneNumber"];
            this.purePhoneNumber = data["purePhoneNumber"];
            this.watermark = data["watermark"] ? Watermark.fromJS(data["watermark"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WxMaPhoneNumberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WxMaPhoneNumberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["phoneNumber"] = this.phoneNumber;
        data["purePhoneNumber"] = this.purePhoneNumber;
        data["watermark"] = this.watermark ? this.watermark.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWxMaPhoneNumberInfo {
    countryCode: string | undefined;
    phoneNumber: string | undefined;
    purePhoneNumber: string | undefined;
    watermark: Watermark | undefined;
}

export class WxMaUserInfo implements IWxMaUserInfo {
    avatarUrl!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    gender!: string | undefined;
    language!: string | undefined;
    nickName!: string | undefined;
    openId!: string | undefined;
    province!: string | undefined;
    unionId!: string | undefined;
    watermark!: Watermark | undefined;

    constructor(data?: IWxMaUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatarUrl = data["avatarUrl"];
            this.city = data["city"];
            this.country = data["country"];
            this.gender = data["gender"];
            this.language = data["language"];
            this.nickName = data["nickName"];
            this.openId = data["openId"];
            this.province = data["province"];
            this.unionId = data["unionId"];
            this.watermark = data["watermark"] ? Watermark.fromJS(data["watermark"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WxMaUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WxMaUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatarUrl"] = this.avatarUrl;
        data["city"] = this.city;
        data["country"] = this.country;
        data["gender"] = this.gender;
        data["language"] = this.language;
        data["nickName"] = this.nickName;
        data["openId"] = this.openId;
        data["province"] = this.province;
        data["unionId"] = this.unionId;
        data["watermark"] = this.watermark ? this.watermark.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWxMaUserInfo {
    avatarUrl: string | undefined;
    city: string | undefined;
    country: string | undefined;
    gender: string | undefined;
    language: string | undefined;
    nickName: string | undefined;
    openId: string | undefined;
    province: string | undefined;
    unionId: string | undefined;
    watermark: Watermark | undefined;
}

export class WxMpQrCodeTicket implements IWxMpQrCodeTicket {
    expireSeconds!: number | undefined;
    ticket!: string | undefined;
    url!: string | undefined;

    constructor(data?: IWxMpQrCodeTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expireSeconds = data["expireSeconds"];
            this.ticket = data["ticket"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): WxMpQrCodeTicket {
        data = typeof data === 'object' ? data : {};
        let result = new WxMpQrCodeTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expireSeconds"] = this.expireSeconds;
        data["ticket"] = this.ticket;
        data["url"] = this.url;
        return data; 
    }
}

export interface IWxMpQrCodeTicket {
    expireSeconds: number | undefined;
    ticket: string | undefined;
    url: string | undefined;
}

export class WxQrCodeForm implements IWxQrCodeForm {
    /** 公众号appId */
    appId!: string | undefined;
    /** 二维码过期时间不得超过30天 */
    expireSeconds!: number | undefined;
    /** 是否临时二维码 */
    isTemp!: boolean | undefined;
    /** 场景值 */
    sceneStr!: string | undefined;

    constructor(data?: IWxQrCodeForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appId = data["appId"];
            this.expireSeconds = data["expireSeconds"];
            this.isTemp = data["isTemp"];
            this.sceneStr = data["sceneStr"];
        }
    }

    static fromJS(data: any): WxQrCodeForm {
        data = typeof data === 'object' ? data : {};
        let result = new WxQrCodeForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["expireSeconds"] = this.expireSeconds;
        data["isTemp"] = this.isTemp;
        data["sceneStr"] = this.sceneStr;
        return data; 
    }
}

export interface IWxQrCodeForm {
    /** 公众号appId */
    appId: string | undefined;
    /** 二维码过期时间不得超过30天 */
    expireSeconds: number | undefined;
    /** 是否临时二维码 */
    isTemp: boolean | undefined;
    /** 场景值 */
    sceneStr: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}